import useFormFieldMeta from "hooks/useFormFieldMeta";
import { Tooltip } from "antd";
import ErrorsSummary from "components/common/ErrorsSummary";

import { TabLabelFieldProps } from "./types";
import { StyledTabLabelField, StyledTabLabelFieldErrorIcon } from "./styles";

const TabLabelField: React.FC<TabLabelFieldProps> = ({
  matcher,
  label,
  children,
}) => {
  const { errors } = useFormFieldMeta(matcher);

  return (
    <Tooltip
      title={!!errors.length && <ErrorsSummary {...{ errors }} />}
      color="red"
      placement="bottom"
    >
      <StyledTabLabelField hasError={!!errors.length}>
        {label}
        {children}
        {!!errors.length && <StyledTabLabelFieldErrorIcon />}
      </StyledTabLabelField>
    </Tooltip>
  );
};

export default TabLabelField;
